import { render, staticRenderFns } from "./SubjectRealignDialog.vue?vue&type=template&id=40425cd4&scoped=true"
import script from "./SubjectRealignDialog.vue?vue&type=script&lang=js"
export * from "./SubjectRealignDialog.vue?vue&type=script&lang=js"
import style0 from "./SubjectRealignDialog.vue?vue&type=style&index=0&id=40425cd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40425cd4",
  null
  
)

export default component.exports